import _ from 'lodash';
import React from 'react';
import { withRouter, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tabs, Layout, Input, Icon, Menu, Dropdown } from 'antd';
import { parseRoute } from '../../util';
import RouterConfig from '../base/route.config.applist';
import DownloadProgress from '../updater/app/progress';
import Header from '../header/header.applist';
import ProjectAction from '../../reducers/project/action';
import StoreService from '../../services/api/store';
import Examples from '../example/data.json';

import List from './list';

import './index.less';
import Emitter from '../../services/emitter';

/**
 * 我的项目页面（pc）
 *
 * @class Projects
 * @extends {React.Component}
 */
class ProjectsPC extends React.Component {

    /**
     * Creates an instance of Projects in pc.
     * @param {any} props
     */
    constructor(props) {
        super(props);
        this.state = {
            tab: 'MENU.PROJECTS'
        };
    }

    componentDidMount() {
        this.syncList();
    }

    syncList = () => {
        Emitter.emit('SyncList', this.successCb, this.failCb);
    }

    successCb = () => {
        console.log('succ');
    }

    failCb = (err) => {
        console.log('err', err);
    }

    handleChange = (key) => {
        this.setState({ key });
    }

    handleChangeTab = (key) => {
        StoreService.set('exampleKey', key);
    }

    renderProjects = () => {
        let { projects } = this.props.project;
        return (
            <List data={projects} isCustom />
        );
    }

    renderExamples = () => {
        const { intlr } = this.props;
        return (
            <section className="example-tabs">
                <Tabs animated={false} defaultActiveKey={StoreService.get('exampleKey') || Examples.categorys[0]}
                    onChange={this.handleChangeTab}>
                    {
                        Examples.categorys.map(key => {
                            const data = Examples.data[key];
                            if (!_.isEmpty(data) && _.isArray(data)) {
                                return (
                                    <Tabs.TabPane tab={intlr.messages[key]} key={key}>
                                        <List data={data} />
                                    </Tabs.TabPane>
                                );
                            } else {
                                return null;
                            }
                        })
                    }
                </Tabs>
            </section>
        );
    }

    renderContent = () => {
        const { intlr, search } = this.props;
        const inputProps = {
            style: { width: 200 },
            prefix: <Icon type="search" />,
            placeholder: intlr.messages['SPRITE.SEARCH.TEXT'],
            onChange: (e) => search(e.target.value)
        };

        const menu = (
            <Menu>
                <Menu.Item key="0">{intlr.messages['PROJECT.SORTBY.RECENT']}</Menu.Item>
            </Menu>
        );

        return (
            <div className="project-pc-content">
                <div className="search-container">
                    <Input {...inputProps} />
                </div>
                <section className="project-body-container">
                    <Tabs animated={false} defaultActiveKey="MENU.PROJECTS" onChange={key => this.handleChange(key)}>
                        <Tabs.TabPane tab={intlr.messages['MENU.PROJECTS']} key="MENU.PROJECTS">
                            {this.renderProjects()}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab={intlr.messages['MENU.FILE.DEMOS']} key="MENU.FILE.DEMOS">
                            {this.renderExamples()}
                        </Tabs.TabPane>
                    </Tabs>
                </section>
                <div>
                    <Dropdown className="sort-container" overlay={menu} trigger={['click']}>
                        <div>{intlr.messages['PROJECT.SORTBY.RECENT']} <Icon type="down" /></div>
                    </Dropdown>
                </div>
            </div>
        );
    }

    routers() {
        const { account, location } = this.props;
        return (
            RouterConfig.map(config => {
                if (config.isPrivate) {
                    if (!account.isLogin) {
                        return (
                            <Redirect key={config.url} to={{
                                pathname: parseRoute('/login'),
                                state: { from: location }
                            }} />
                        );
                    }
                }
                return (
                    <Route exact={config.exact} key={config.url}
                        path={config.url}
                        component={config.component} />
                );
            })
        );
    }

    openProjectTarget() {
        return (
            <input id="OpenProjectTarget" type="file" style={{ visibility: 'hidden', position: 'absolute', zIndex: -1 }} />
        );
    }

    downloadLink() {
        return (
            <a id="DownloadFileTarget" style={{ visibility: 'hidden', zIndex: -100, position: 'absolute' }}></a>
        );
    }

    render() {
        return (
            <Layout className="root-layout root-layout-list">
                {/* 导航 */}
                <Header />
                {/* 项目列表 */}
                {this.renderContent()}
                {/* 其他页面路由 */}
                {this.routers()}
                {/* 下载更新进度 */}
                <DownloadProgress />
                {/* 保存文件导出使用的链接 */}
                {this.downloadLink()}
                {/* 打开选择文件标识 */}
                {this.openProjectTarget()}
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    project: state.project
});

const mapDispatchToProps = dispatch => ({
    list: (type) => dispatch(ProjectAction.list(type)),
    search: (text) => dispatch(ProjectAction.search(text))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectsPC));